"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../../styles"));
var _EDSContext = require("../../EDSContext/EDSContext");
var _MobileStepper = _interopRequireDefault(require("@mui/material/MobileStepper"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _lib = require("@ellucian/ds-icons/lib");
var _excluded = ["classes", "edsContext", "steps", "loops", "activeStep", "handleActiveStep", "mode"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = function styles(theme) {
  return {
    root: {},
    dot: {
      width: '.375rem',
      height: '.375rem',
      alignSelf: 'center',
      background: theme.palette.grey['500']
    },
    dotLg: {
      width: '.5rem',
      height: '.5rem',
      background: theme.palette.grey['500']
    },
    dotMd: {
      width: '.375rem',
      height: '.375rem',
      alignSelf: 'center',
      background: theme.palette.grey['500']
    },
    dotSm: {
      width: '.25rem',
      height: '.25rem',
      alignSelf: 'center',
      background: theme.palette.grey['500']
    },
    dotActive: {
      background: theme.palette.ctaColor.base
    },
    // visiblity hidden is better than display none here
    // hidden retains the space for the arrows, in case they dynamically change
    hiddenArrow: {
      visibility: 'hidden'
    }
  };
};

/**
 * Stepper for Carousel
 */
var CarouselStepper = function CarouselStepper(props) {
  var classes = props.classes,
    edsContext = props.edsContext,
    steps = props.steps,
    loops = props.loops,
    activeStep = props.activeStep,
    handleActiveStep = props.handleActiveStep,
    mode = props.mode,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);

  // activeStep may be greater than 4
  // keeps track of what visual position the active step is on (1-5); based off of index
  var _useState = (0, _react.useState)(0),
    activeStepPosition = _useState[0],
    setActiveStepPosition = _useState[1];
  var stepperRef = (0, _react.useRef)(null);
  var stepCounter = steps;

  // steps = dots on the steppers
  // we only show 5 steps at any given time
  if (steps > 6) {
    stepCounter = 5;
  }

  // handles resizing & positions of dots
  (0, _react.useEffect)(function () {
    if (steps > 6) {
      // 0 and 1 should always be first and second dot
      if (activeStep === 0 || activeStep === 1) {
        setActiveStepPosition(activeStep);
      }

      // if max minus current is 1, then it's always fourth dot
      else if (steps - activeStep - 1 === 1) {
        setActiveStepPosition(3);
      }

      // if max minus current is 0, then it's always last dot
      else if (steps - activeStep - 1 === 0) {
        setActiveStepPosition(4);
      }

      // any other combination, it should remain in the middle
      else {
        setActiveStepPosition(2);
      }

      // this gives you only .dot
      // scope is important to not receive the parent div back
      var childArray = stepperRef.current.querySelectorAll(':scope > div > div');

      // reset any existing classes
      childArray.forEach(function (node) {
        return node.classList.remove(classes.dotLg, classes.dotMd, classes.dotSm);
      });

      // default is always medium
      childArray.forEach(function (node) {
        return node.classList.add(classes.dotMd);
      });

      // apply large and remove medium to the action
      childArray[activeStepPosition].classList.remove(classes.dotMd);
      childArray[activeStepPosition].classList.add(classes.dotLg);

      // apply small to the outermost dot
      if (activeStepPosition < 2) {
        childArray[4].classList.remove(classes.dotMd);
        childArray[4].classList.add(classes.dotSm);
      }

      // apply small to the outermost dot
      if (activeStepPosition > 2) {
        childArray[0].classList.remove(classes.dotMd);
        childArray[0].classList.add(classes.dotSm);
      }

      // apply small to the outermost dot
      if (activeStepPosition === 2) {
        childArray[0].classList.remove(classes.dotMd);
        childArray[0].classList.add(classes.dotSm);
        childArray[4].classList.remove(classes.dotMd);
        childArray[4].classList.add(classes.dotSm);
      }
    } else {
      // if there's less than 6, then we don't need to animate the dots or do anything fancy.
      // just make the position equal to the activeStep of the carousel
      setActiveStepPosition(activeStep);
      var _childArray = stepperRef.current.querySelectorAll(':scope > div > div');
      // Setting activeStep to dotLg to make it easier for colorblind people to identify the active dot
      _childArray[activeStepPosition].classList.add(classes.dotLg);
    }
  }, [activeStep, activeStepPosition, classes, steps]);
  return /*#__PURE__*/_react.default.createElement(_MobileStepper.default, (0, _extends2.default)({
    ref: stepperRef,
    variant: "dots",
    position: "static",
    steps: stepCounter,
    activeStep: activeStepPosition,
    classes: {
      root: classes.root,
      dotActive: classes.dotActive,
      dot: classes.dot
    },
    backButton: /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      "aria-label": edsContext.formatMessage('component.CarouselStepper.backButton'),
      color: "gray",
      onClick: function onClick() {
        return handleActiveStep(activeStep - 1);
      },
      disabled: activeStep === 0 && !loops,
      className: mode !== 'footer' ? classes.hiddenArrow : undefined
    }, edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_lib.ChevronRight, null) : /*#__PURE__*/_react.default.createElement(_lib.ChevronLeft, null)),
    nextButton: /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      "aria-label": edsContext.formatMessage('component.CarouselStepper.nextButton'),
      color: "gray",
      onClick: function onClick() {
        return handleActiveStep(activeStep + 1);
      },
      disabled: activeStep === steps - 1 && !loops,
      className: mode !== 'footer' ? classes.hiddenArrow : undefined
    }, edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_lib.ChevronLeft, null) : /*#__PURE__*/_react.default.createElement(_lib.ChevronRight, null))
  }, rest));
};
CarouselStepper.displayName = 'CarouselStepper';
CarouselStepper.propTypes = {
  classes: _propTypes.default.object,
  /**
   */
  className: _propTypes.default.string,
  /**
   */
  edsContext: _propTypes.default.object,
  /**
   * The starting position of the active node of the Carousel, starting from 1.
   */
  activeStep: _propTypes.default.number,
  /**
   * The array length of the nodes passed in, starting from 0.
   */
  steps: _propTypes.default.number,
  /**
   * The function from the parent which monitors what the activeStep should be.
   */
  handleActiveStep: _propTypes.default.func,
  /**
   * Determines if the Stepper should loop.
   */
  loops: _propTypes.default.bool,
  /**
   * Determines where navigation arrows reside. Arrows only display in stepper when mode is set to footer
  */
  mode: _propTypes.default.oneOf(['footer', 'floating'])
};
CarouselStepper.defaultProps = {
  loops: true
};
var _default = exports.default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(CarouselStepper));